import React, { useEffect, useRef } from "react";

const DemaoVideos = () => {
  const videoRefs = useRef([]);

  useEffect(() => {
    const handlePlay = (index) => {
      videoRefs.current.forEach((video, i) => {
        if (i !== index && video && !video.paused) {
          video.pause();
        }
      });
    };

    // Attach play event listeners
    videoRefs.current.forEach((video, index) => {
      if (video) {
        video.addEventListener("play", () => handlePlay(index));
      }
    });

    // Cleanup
    return () => {
      videoRefs.current.forEach((video) => {
        if (video) {
          video.removeEventListener("play", handlePlay);
        }
      });
    };
  }, []);

  return (
    <div className="contentarea pt-5">
      <div className="sliderInrHdng" style={{ position: "static" }}>
        <h2>
          Demo<span className="hdngBrkr"> Videos</span>
        </h2>
      </div>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div className="boxDiv">
        <h5 className="card-title">Demo Video (School-Login)</h5>
          <video className="mb-0"
            controls
            width="100%"
            ref={(el) => (videoRefs.current[0] = el)}
          >
            <source
              src="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/School_Login_Demo.mp4?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div className="boxDiv">
          <h5 className="card-title">Demo Video (Faculty-Login)</h5>
          <video className="mb-0"
            controls
            width="100%"
            ref={(el) => (videoRefs.current[1] = el)}
          >
            <source
              src="https://aictevoicestaanuvadini.blob.core.windows.net/ecoclubs/Faculty_Login_Demo.mp4?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemaoVideos;
